import React from 'react'
import { useReactiveVar } from '@apollo/client'
import { Box, makeStyles, Toolbar } from '@material-ui/core'
import { useTranslation } from 'react-i18next'
import { EnergyBusFragment } from '../../generated/graphql'
import { SystemContainerDrawer } from '../system-container/SystemContainerDrawer'
import {
  SystemContainerHeader,
  useHeaderStyles,
} from '../system-container/SystemContainerHeader'
import { Sidebar } from '../layout/Sidebar'
import { EnergyBusDrawerContent } from './EnergyBusDrawerContent'
import { EnergyBusSidebarContent } from './EnergyBusSidebarContent'
import {
  calculatorVar,
  comparisonVersionCalculatorVar,
} from '../../apollo/reactive-vars'

const useStyles = makeStyles({
  content: {
    display: 'flex',
    flexDirection: 'column',
    flexGrow: 1,
    height: '100%',
  },
})

type Props = {
  energyBus?: EnergyBusFragment
  onClose: () => void
}

export function EnergyBusDrawer({
  energyBus,
  onClose,
}: Props): React.ReactElement {
  const classes = useStyles()
  const headerClasses = useHeaderStyles()
  const { t } = useTranslation()
  const calculator = useReactiveVar(calculatorVar)
  const comparisonCalculator = useReactiveVar(comparisonVersionCalculatorVar)

  const energyBusCalculator = calculator?.findEnergyBus()
  const comparisonEnergyBusCalculator = comparisonCalculator?.findEnergyBus()

  return (
    <SystemContainerDrawer isOpen={energyBus !== undefined} onClose={onClose}>
      <SystemContainerHeader
        closeLabel={t('energyBus.close')}
        onClose={onClose}
        containerName={t('energyBus.name')}
      />

      {energyBus && energyBusCalculator && (
        <Box display="flex">
          <Sidebar>
            {/* Allocate space for app bar. */}
            <Toolbar className={headerClasses.toolbar} />

            <EnergyBusSidebarContent
              energyBus={energyBusCalculator}
              comparisonEnergyBus={comparisonEnergyBusCalculator}
            />
          </Sidebar>

          <main className={classes.content}>
            {/* Allocate space for app bar. */}
            <Toolbar className={headerClasses.toolbar} />

            <Box flexGrow={1}>
              <EnergyBusDrawerContent energyBus={energyBus} onClose={onClose} />
            </Box>
          </main>
        </Box>
      )}
    </SystemContainerDrawer>
  )
}
